import React from "react";
import "./LoadingSpinner.css";

const LoadingSpinner = () => {
  return <div className="lds-dual-ring fixed mx-auto top-1/2 z-10"></div>;
};

export default LoadingSpinner;
